import { HighChartDataBase } from './high-chart-data-base';

export class PolarHighChartData extends HighChartDataBase {

    private reportIsRAND():boolean {
        return this.reportName.indexOf("RAND") > -1;
    }

    private setRANDLegends(): string[] {
        let i = 0;
        let minus = this.detailedTable.rows[i].length < 6 ? 2 : 3;
        let customLegends = [];
        this.chartSeries.forEach(serie => {
            let rowItems = this.detailedTable.rows[i];
            customLegends.push(`${serie.name}, ${rowItems[rowItems.length-minus]} pat.`);
            i++;
            minus--;
        });
        return customLegends;
    }

    public getHighChartOptions(): Object {
        let that = this;

        let customLegends;
        if (this.reportIsRAND()) customLegends = this.setRANDLegends();

        return {
            accessability: { enabled: false },
            chart: {
                type: 'line',
                height: this.chartHeight,
                polar: true,
                renderTo: 'container'
            },
            title: { 
                text: this.chartTitle,
                widthAdjust: -150,
                margin: 30
            },
            subtitle: { 
                text: this.chartSubTitle ,
                widthAdjust: -150
            },
            pane: {
                size: '80%'
            },
            xAxis: {
                categories: this.categories,
                tickmarkPlacement: 'on',
                lineWidth: 0,
                gridLineColor: '#e5ebee',
                gridLineWidth: 2,
                min: Number.isNaN(this.xMinValue) ? null : this.xMinValue,
                max: Number.isNaN(this.xMaxValue) ? null : this.xMaxValue,

                labels: {
                    style: {
                        "whiteSpace": "nowrap",
                        "textOverflow": "none"
                    }
                }
            },
            yAxis: {
                gridLineInterpolation: 'polygon',
                lineWidth: 0,
                gridLineColor: '#e5ebee',
                gridLineWidth: 2,
                tickInterval: this.yMaxValue == 100 ? 25 : null,
                min: 0,
                max: Number.isNaN(this.yMaxValue) ? null : this.yMaxValue,
            },
            series: this.chartSeries,
            tooltip: {
                formatter: function() { return that.getDefaultTooltipText(this, true); },
                shared: true,
                useHTML: true
            },
            plotOptions: {
                series: {
                    fillOpacity: 0.35
                }
            },
            colors: this.defaultColors,
            legend: {
                enabled: this.chartSeries.length > 1 ? true : false,
                labelFormatter: function() { 
                    if (customLegends) return customLegends[this.index]
                    else return this.name;
                }
            },
            credits: {
                text: this.credits,
                href: this.creditsLink
            },

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: this.chartWidth
                    }
                }]
            },

            exporting: {
                filename: "diagram_" + this.chartTitle
            }
        };
    }

}
